import { GetStaticProps, NextPage } from 'next';
import React from 'react';

import HelpTemplate from '@/components/templates/HelpTemplate';
import {
  ARTICLE_CATEGORY_POST_URL,
  ARTICLE_SLUG_URL,
  ARTICLE_TAG_URL,
  ARTICLE_URL,
  HELP_CATEGORIES_URL,
} from '@/constants/urls';
import {
  fetchContent,
  IArticleTags,
  IPageCategory,
  parseArticleTags,
  parseCategory,
} from '@/services/getHelpPageData';

interface IProps {
  title: string;
  content: string;
  slug: string;
  articles: IPageCategory[];
  articleCategories: IPageCategory[];
  articleTags: IArticleTags[];
  categoryTags: IArticleTags[];
}

const Terms: NextPage<IProps> = ({
  title,
  content,
  articles,
  slug,
  articleCategories,
  articleTags,
  categoryTags,
}) => {
  return (
    <HelpTemplate
      content={content}
      slug={slug}
      title={title}
      articles={articles}
      articleCategories={articleCategories}
      articleTags={articleTags}
      categoryTags={categoryTags}
    />
  );
};
export async function getStaticPaths() {
  return {
    paths: [
      {
        params: { slug: 'privacy-policy' },
      },
      {
        params: { slug: 'outdoorsy-terms-and-conditions' },
      },
    ],
    fallback: 'blocking',
  };
}

export const getStaticProps: GetStaticProps<IProps> = async ({ params }) => {
  const { slug } = params || {};

  if (typeof slug === 'string') {
    const [pageContent, articles, articleCategories] = await Promise.all([
      fetchContent(`${ARTICLE_SLUG_URL}${slug}`),
      fetchContent(ARTICLE_URL),
      fetchContent(HELP_CATEGORIES_URL),
    ]);

    if (pageContent.length) {
      const { id, title, content } = pageContent[0];

      const [articleTags, categoryTags] = await Promise.all([
        fetchContent(`${ARTICLE_TAG_URL}${id}`),
        fetchContent(`${ARTICLE_CATEGORY_POST_URL}${id}`),
      ]);

      return {
        props: {
          title: title?.rendered,
          content: content?.rendered,
          slug,
          id,
          articles: parseCategory(articles.filter((_: string, i: number) => i < 5)),
          articleCategories: parseCategory(articleCategories),
          articleTags: parseArticleTags(articleTags),
          categoryTags: parseArticleTags(categoryTags),
        },
        revalidate: 60,
      };
    }
  }

  return {
    notFound: true,
    revalidate: 60,
  };
};

export default Terms;
